//todas las posibles
//PROD: https://api.doctor.video
//NEW_PROD:  https://backend-drvideo.ikeasistencia.com
//PRE-PROD: https://api-pre-prod-ike.doctor.video
//UAT: https://api-uat-ike.doctor.video
//QA: https://back-dr-video.dev-pruebas.com
//DEV: https://api-dev-ike.doctor.video
export const URL_API = "https://backend-drvideo.ikeasistencia.com";
//export const URL_API = "https://back-dr-video.dev-pruebas.com";
// export const URL_API = "http://localhost:8080";
//export const URL_API = "https://back-dr-video.dev-pruebas.com";


//todas las posibles
//PROD: https://servicios-online.ikeasistencia.com
//PRE-PROD:https://pre-prod.doctor.video
//UAT: https://uat-ike.doctor.video
//QA: https://front-dr-video.dev-pruebas.com
//DEV: https://dev-ike.doctor.video
export const URL_PAGE = "https://servicios-online.ikeasistencia.com";

// BAZ Account ID that requires card last digits in externalId
export const BAZ_ACCOUNT_ID = 49;